import React, { Component } from 'react';
import dayjs from "dayjs";
import axios from "axios";
import ApiURL from "../../../api/ApiURL";
import cogoToast from "cogo-toast";

class HotelSubBooking extends Component {
    //Constructor
    constructor(props) {
        super(props);
        this.state = {
            tcData: props.tcData || [],
            locationData: props.locationData || [],
            vendorData: props.vendorData || [],
            roomCategoryData: props.roomCategoryData || [],
            vendorCategoryId: props.vendorCategoryId || 0, //Hotel Vendor
            subBookingId: props.subBookingId || 0,
            subBookingNo: props.subBookingNo || '',
            subBookingType: props.subBookingType || 'Hotel',
            bookingId: props.bookingId,
            travelCircuitId: props.travelCircuitId || 0,
            locationId: props.locationId || 0,
            vendorId: props.vendorId || 0,
            roomCategoryId: props.roomCategoryId || 0,
            noOfRooms: props.noOfRooms || 0,
            noOfEB: props.noOfEB || 0,
            noOfCNB: props.noOfCNB || 0,
            mealPlan: props.mealPlan || '',
            checkInDate: props.checkInDate || '',
            checkOutDate: props.checkOutDate || '',
            noOfDays: props.noOfDays || 0,
            comment: props.comment || '',
            payableAmount: props.payableAmount || 0,
            paidAmount: props.paidAmount || 0,
            dueAmount: props.dueAmount || 0,
            userId: props.userId || 1,
            isActive: props.isActive || true,
        };
    }
    //ComponentDidUpdate
    componentDidUpdate(prevProps) {
        const prevPropsString = JSON.stringify(prevProps);
        const currentPropsString = JSON.stringify(this.props);

        if (prevPropsString !== currentPropsString) {
            // Update state with new props
            this.setState({
                ...this.state,
                tcData: this.props.tcData,
                locationData: this.props.locationData,
                vendorData: this.props.vendorData,
                roomCategoryData: this.props.roomCategoryData,
                vendorCategoryId: this.props.vendorCategoryId,
                subBookingId: this.props.subBookingId,
                subBookingNo: this.props.subBookingNo,
                subBookingType: this.props.subBookingType,
                bookingId: this.props.bookingId,
                travelCircuitId: this.props.travelCircuitId,
                locationId: this.props.locationId,
                vendorId: this.props.vendorId,
                roomCategoryId: this.props.roomCategoryId,
                noOfRooms: this.props.noOfRooms,
                noOfEB: this.props.noOfEB,
                noOfCNB: this.props.noOfCNB,
                mealPlan: this.props.mealPlan,
                checkInDate: this.props.checkInDate,
                checkOutDate: this.props.checkOutDate,
                noOfDays: this.props.noOfDays,
                comment: this.props.comment,
                payableAmount: this.props.payableAmount,
                paidAmount: this.props.paidAmount,
                dueAmount: this.props.dueAmount,
                userId: this.props.userId,
                isActive: true,
            });
        }
    }
    //OnChangeHandler
    onChangeHandler = (e) => {
        this.props.subBookingHandler(e);
    }
    //Get Date difference in days
    /* dateDiffInDays = (e) => {
        e.preventDefault();
        const date1 = dayjs(this.state.checkInDate);
        const date2 = dayjs(this.state.checkOutDate);
        // Calculate the difference in days
        const diffInDays = date2.diff(date1, 'day');
        this.setState({ noOfDays: diffInDays })
    } */
    //Save Sub-Booking
    saveSubBooking = (e) => {
        e.preventDefault();

        if (this.state.travelCircuitId === 0) {
            cogoToast.error("Travel Circuit is required!", { position: "bottom-center" });
        }
        else if (this.state.locationId === 0) {
            cogoToast.error("Location is required!", { position: "bottom-center" });
        }
        else if (this.state.vendorId === 0) {
            cogoToast.error("Hotel is required!", { position: "bottom-center" });
        }
        else if (this.state.roomCategoryId === 0) {
            cogoToast.error("Room Category is required!", { position: "bottom-center" });
        }
        else if (this.state.noOfRooms === '' || this.state.noOfRooms === 0) {
            cogoToast.error("No of room is required!", { position: "bottom-center" });
        }
        else if (this.state.mealPlan === '') {
            cogoToast.error("Meal plan is required!", { position: "bottom-center" });
        }
        else if (this.state.checkInDate === '') {
            cogoToast.error("Check in date is required!", { position: "bottom-center" });
        }
        else if (this.state.checkOutDate === '') {
            cogoToast.error("Check out date is required!", { position: "bottom-center" });
        }
        else if (this.state.payableAmount === '' || this.state.payableAmount === 0) {
            cogoToast.error("Vendor payable amount is required!", { position: "bottom-center" });
        }
        else {

            let selectedTravelCircuitId = parseInt(this.state.travelCircuitId);
            let selectedLocationId = parseInt(this.state.locationId);
            let selectedVendorId = parseInt(this.state.vendorId);
            let selectedRoomCategoryId = parseInt(this.state.roomCategoryId);
            const selectedTravelCircuitName = this.state.tcData.find(v => v.TravelCircuitId === selectedTravelCircuitId)?.TravelCircuitName;
            const selectedLocationName = this.state.locationData.find(v => v.LocationId === selectedLocationId)?.LocationName;
            const selectedVendorName = this.state.vendorData.find(v => v.VendorId === selectedVendorId)?.VendorName;
            //const selectedBookingNo = this.state.subBookingNo != '' ? this.state.subBookingNo : dayjs(new Date()).format('DDMMYYhhmmss');

            let subBooking = {
                SubBookingId: this.state.subBookingId,
                SubBookingNo: '',
                SubBookingType: this.state.subBookingType,
                BookingId: this.state.bookingId,
                TravelCircuitId: selectedTravelCircuitId,
                TravelCircuitName: selectedTravelCircuitName,
                LocationId: selectedLocationId,
                LocationName: selectedLocationName,
                VendorId: selectedVendorId,
                VendorName: selectedVendorName,
                RoomCategoryId: selectedRoomCategoryId,
                NoOfRooms: this.state.noOfRooms,
                NoOfEB: this.state.noOfEB || 0,
                NoOfCNB: this.state.noOfCNB || 0,
                MealPlan: this.state.mealPlan,
                CheckInDate: this.state.checkInDate,
                CheckOutDate: this.state.checkOutDate,
                NoOfDays: this.state.noOfDays,
                Comment: this.state.comment,
                PayableAmount: parseFloat(this.state.payableAmount),
                PaidAmount: this.state.paidAmount,
                DueAmount: this.state.dueAmount,
                UserId: this.state.userId,
                IsActive: true
            };

            //API call to save individual sub-booking data
            axios
                .post(ApiURL.SaveSubBooking, subBooking)
                .then((response) => {
                    let respData = response.data;
                    console.log(respData);
                    if (respData.StatusCode === 200) {
                        cogoToast.success(respData.Message, { position: "bottom-center" });
                        let sbData = respData.DataResult;
                        if (sbData !== null) {
                            subBooking.SubBookingId = sbData.SubBookingId;
                            subBooking.SubBookingNo = sbData.SubBookingNo;
                            this.props.addSubBookings(subBooking);
                            this.closeModal();
                        }
                    }
                    else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                        cogoToast.warn(respData.Message, { position: "bottom-center" });
                    }
                    else if (respData.StatusCode === 500) {
                        cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                    }
                })
                .catch((error) => {
                    cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                });


        }
    }
    //Reset Fields
    resetFields = () => {
        this.setState({
            ...this.state,
            subBookingId: 0,
            subBookingNo: '',
            subBookingType: '',
            bookingId: 0,
            travelCircuitId: 0,
            locationId: 0,
            vendorId: 0,
            roomCategoryId: 0,
            noOfRooms: '',
            noOfEB: '',
            noOfCNB: '',
            mealPlan: '',
            checkInDate: '',
            checkOutDate: '',
            noOfDays: '',
            comment: '',
            payableAmount: 0,
            paidAmount: 0,
            dueAmount: 0,
            isActive: true
        })
    }
    //Close Modal
    closeModal = () => {
        this.resetFields();
        this.props.closeModal();
    }
    //Render 
    render() {
        const { subBookingNo, tcData, locationData, vendorData, roomCategoryData, travelCircuitId, locationId, vendorId,
            roomCategoryId, noOfRooms, noOfEB, noOfCNB, mealPlan, checkInDate, checkOutDate, noOfDays, comment,
            payableAmount, paidAmount, dueAmount } = this.state;

        return (
            <>
                {/* <!-- Hotel modal section--> */}
                <div className={this.props.showModal === true ? "modal show-modal  modalWrapper" : "modal"}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">
                                    Manage {this.props.subBookingType} Sub-Booking
                                    {subBookingNo !== '' ? ' [' + subBookingNo + '] ' : ''}
                                </h3>
                                <i className="fa-regular fa-circle-xmark text-danger" onClick={this.closeModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <form>
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <label className="form-label">Travel Circuit <span className='text-danger'>*</span></label>
                                                <select
                                                    name="travelCircuitId"
                                                    value={travelCircuitId}
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    onChange={this.onChangeHandler}
                                                >
                                                    <option value="0">-- Select --</option>
                                                    {tcData.map((item, index) => (
                                                        <option key={index} value={item.TravelCircuitId}>
                                                            {item.TravelCircuitName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Location <span className='text-danger'>*</span></label>
                                                <select
                                                    name="locationId"
                                                    value={locationId}
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    onChange={this.onChangeHandler}
                                                >
                                                    <option value="0">-- Select --</option>
                                                    {locationData.map((item, index) => (
                                                        <option key={index} value={item.LocationId}>
                                                            {item.LocationName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Hotel Name <span className='text-danger'>*</span></label>
                                                <select
                                                    name="vendorId"
                                                    value={vendorId}
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    onChange={this.onChangeHandler}
                                                >
                                                    <option value="0">-- Select --</option>
                                                    {vendorData.map((item, index) => (
                                                        <option key={index} value={item.VendorId}>
                                                            {item.VendorName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Room Category <span className='text-danger'>*</span></label>
                                                <select
                                                    name="roomCategoryId"
                                                    value={roomCategoryId}
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    onChange={this.onChangeHandler}
                                                >
                                                    <option value="0">-- Select --</option>
                                                    {roomCategoryData.map((item, index) => (
                                                        <option key={index} value={item.RoomCategoryId}>
                                                            {item.RoomCategoryName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">No. of Rooms <span className='text-danger'>*</span></label>
                                                <input type="number" name="noOfRooms" className="form-control-sm border border-primary w-100" value={noOfRooms} onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">No. of EB</label>
                                                <input type="number" name="noOfEB" className="form-control-sm border border-primary w-100" value={noOfEB} onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">No. of CNB</label>
                                                <input type="number" name="noOfCNB" className="form-control-sm border border-primary w-100" value={noOfCNB} onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Meal Plan <span className='text-danger'>*</span></label>
                                                <select name="mealPlan"
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    value={mealPlan}
                                                    onChange={this.onChangeHandler}
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="EP">EP</option>
                                                    <option value="CP">CP</option>
                                                    <option value="MAP">MAP</option>
                                                    <option value="APAI">APAI</option>
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Check In <span className='text-danger'>*</span></label>
                                                <input type="date" name="checkInDate" className="form-control-sm border border-primary w-100" value={checkInDate} onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Check Out <span className='text-danger'>*</span></label>
                                                <input type="date" name="checkOutDate" className="form-control-sm border border-primary w-100" value={checkOutDate} onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">No. of Days</label>
                                                <input type="text" name="noOfDays" className="form-control-sm border border-primary w-100" value={noOfDays} disabled onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="col-md-12">
                                                <label className="form-label">Comments</label>
                                                <textarea
                                                    name="comment"
                                                    value={comment}
                                                    className="form-control border border-secondary"
                                                    rows="2"
                                                    onChange={this.onChangeHandler}>
                                                </textarea>
                                            </div>
                                        </div>
                                        <div className="card mb-1 mt-2">
                                            <div className="card-head text-center">Vendor Payment</div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label className="form-label">Vendor Payable <span className='text-danger'>*</span></label>
                                                        <input type="number" name="payableAmount" className="form-control-sm border border-primary w-100" value={payableAmount} onChange={this.onChangeHandler} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label">Paid to Vendor</label>
                                                        <input type="number" name="paidAmount" className="form-control-sm border border-primary w-100" value={paidAmount} disabled onChange={this.onChangeHandler} />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label">Due to Vendor</label>
                                                        <input type="number" name="dueAmount" className="form-control-sm border border-primary w-100" value={dueAmount} disabled onChange={this.onChangeHandler} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button className="btn btn-success button-box-shadow" onClick={this.saveSubBooking}>
                                    <i className="fa-solid fa-circle-check"></i> Save
                                </button>

                                <button className="btn btn-secondary button-box-shadow" onClick={this.closeModal}>
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Hotel modal section--> */}
            </>
        );
    }
}

export default HotelSubBooking;